import {createStore} from 'vuex'
import donation from './donation'
import iframe from './iframe'

export default createStore({
    modules: {donation, iframe},
})
